import apiClient from '@/services/api';
import { useAuthStore } from '@/stores/auth';
const API_URL = '/maintenance_requests';

const sanitize = d => {
  const authStore = useAuthStore();
  d.company_id = d.company_id || authStore.currentUser?.company_id;
  return ({
  ...d,
  estimated_cost: d.estimated_cost !== '' ? Number(d.estimated_cost) : null,
  priority: d.priority?.toLowerCase(),
  status: d.status?.toLowerCase()
});}

export default {
  async getAll()          {
    const authStore = useAuthStore();
    const userCompanyId = authStore.currentUser?.company_id;
    let url = API_URL;
    if (userCompanyId) {
      const filter = {"field":"company_id","value":userCompanyId};
      url += `?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }
    const r = await apiClient.get(url); return r.data; },
  async get(id)           { const r = await apiClient.get(`${API_URL}/${id}`); return r.data; },
  async create(data)      { const r = await apiClient.post(API_URL, sanitize(data)); return r.data; },
  async update(id, data)  { const r = await apiClient.put(`${API_URL}/${id}`, sanitize(data)); return r.data; },
  async delete(id)        { return apiClient.delete(`${API_URL}/${id}`); }
};
